var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-top-section'),_c('categories-section'),_c('products-section'),_c('BannerProductSection'),_c('about-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }